<template>
  <div class="main_div">
    <div class="main_expenses">
      <div v-for="(expense, index) in editableExpenses" :key="index" v-bind:class="{ deleted: expense.is_deleted }" class="row expense">
        <div class="col-md-5 flex">
<!--          <template v-if="(storeId != expense.store_id) && expense.id">-->
          <template v-if="expense.id">
            <div class="pl-1 store_name">
              <p v-if="storeId != expense.store_id" class="m-0">{{storeNames[expense.store_id]}}</p>
              <p class="m-0 fs-11 text-muted">{{users[expense.user_id]}}</p>
              <p v-if="storeId == expense.store_id" class="m-0 fs-11 text-muted">{{moment(expense.created_at, 'DD.MM.YYYY HH:mm')}}</p>
            </div>
          </template>
          <template v-if="(!userId || userId == 0) && !expense.id">
            <select v-model="expense.store_id" class="form-control" :disabled="expense.is_deleted || expense.disabled">
              <option value="0">-Общие расходы-</option>
              <option v-for="(store, storeId) in $AllStores" :value="storeId">{{store.short_title}}</option>
            </select>
          </template>
          <template v-if="allowedExpenses.some(e => e.id === expense.type_id || !expense.type_id)">
            <select v-model="expense.type_id" class="form-control" :disabled="expense.is_deleted || expense.disabled">
              <option value="0" disabled>Выберите тип расхода</option>
              <option v-for="type in allowedExpenses" :value="type.id">{{type.title}}</option>
            </select>
          </template>
          <template v-else>
            <input type="text" v-model="allExpensesTypes[expense.type_id]" placeholder="Нет доступных типов расходов" :disabled="true" class="form-control">
          </template>
        </div>
        <div class="col-md-4">
          <input type="text" v-model="expense.comment" placeholder="Комментарий" :disabled="expense.is_deleted || expense.disabled" class="form-control">
        </div>
        <div class="col-md-3">
          <div class="form-group flex">
            <input type="number" placeholder="сумма" class="form-control" :disabled="expense.is_deleted || expense.disabled" v-model="expense.sum">
            <select v-model="expense.currency_id" class="form-control" :disabled="expense.is_deleted || expense.disabled">
              <option v-for="(currency, id) in currencies" :value="id">{{currency}}</option>
            </select>
            <template v-if="storeId == expense.store_id || storeId == 0">
              <button @click="removeExpense(index)" :disabled="expense.is_deleted || expense.disabled" class="btn btn-danger"><i class="icon-fa icon-fa-remove"></i></button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div>

    </div>

    <div class="flex flex-jc-between">
      <button @click="addExpense" class="btn btn-sm btn-info">Новый расход</button>
      <vue-ladda v-if="getAllExpenses().length" @click="saveExpenses" button-class="btn btn-sm btn-success"
                 data-style="zoom-in"
                 :loading="btnLoading">Сохранить расходы
      </vue-ladda>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'
  import moment from 'moment'

  export default {
    components: {
      VueLadda
    },
    props: ['storeId', 'users', 'storeNames', 'expenses', 'userId', 'expensesTypes', 'currencies', 'date', 'updateExpenses', 'allowedExpenses', 'allExpensesTypes'],
    data() {
      return {
        newExpenses: [],
        btnLoading: false,
        type: 0,
        editableExpenses: [],
      }
    },
    computed: {
      $AllStores() {
        const stores = this.$store.getters['platform/stores'];
        delete stores[2];
        delete stores[1];
        return stores;
      }
    },
    mounted() {
      const expenses = this.prepareExpenses();
      this.editableExpenses = [...expenses];
    },
    methods: {
      prepareExpenses() {
        const expenses = [];
        this.expenses.forEach((e) => {
          if (this.storeId != e.store_id && e.id) {
            e.disabled = true;
          }
          expenses.push(e);
        })
        return expenses;
      },
      moment: function (date, format) {
        if (!date) return;
        return moment(date).format(format);
      },
      getAllExpenses() {
        const expenses = [...this.expenses, ...this.newExpenses, ...this.editableExpenses];
        expenses.forEach((e) => {
          // if (this.userId != e.user_id && e.id) {
          if (this.storeId != e.store_id && e.id) {
            e.disabled = true;
          }
        })
        return expenses;
      },
      allowToEdit(expense) {
        if (!expense.id) return true;
        let allow = false;
        this.allowedExpenses.forEach((e) => {
          if (!e.id) allow = true;
          if (e.id == expense.type_id) allow = true;
        })
        return allow;
      },
      removeExpense(index) {
        this.editableExpenses[index].is_deleted = true;
        this.editableExpenses = [...this.editableExpenses];
        // expense.is_deleted = true;
      },
      addExpense() {
        // this.newExpenses.push({
        this.editableExpenses.push({
          id: null,
          type_id: 0,
          store_id: this.storeId,
          is_deleted: false,
          disabled: false,
          currency_id: 33,
          comment: null,
          sum: null
        })
      },
      async saveExpenses() {
        this.btnLoading = true;
        let validate = true;
        const allExpenses = [...this.expenses, ...this.newExpenses]
        allExpenses.forEach((exp) => {
          if (!exp.is_deleted) {
            if (!exp.sum || !exp.type_id) validate = false;
          }
        })

        if (!validate) {
          toastr['warning']('Не все поля заполнены', 'Ошибка');
          this.btnLoading = false;
          return;
        }

        let expenses = [];
        [...this.expenses, ...this.newExpenses, ...this.editableExpenses].forEach((e) => {
          if (!expenses.find((se) => e.id && e.id === se.id)){
            expenses.push(e);
          }
        })

        const {data} = await api.post('/reports/updateExpenses', {
          expenses: expenses,
          // expenses: this.editableExpenses,
          userId: this.userId,
          date: this.date,
          storeId: this.storeId
        });
        if (data.success) {
          toastr['success']('Сохранено');
          this.newExpenses = [];
          this.editableExpenses = data.expenses;
          // this.updateExpenses();
        } else {
          toastr['warning']('Ошибка');
        }
        this.btnLoading = false;
      }
    }
  }

</script>

<style scoped>
  .main_expenses .form-group {
    margin-bottom: 5px;
  }

  .store_name {
    margin: auto;
    /*line-height: 100%;*/
    min-width: 170px;
  }

  .expense.deleted {
    opacity: .3;
  }

  .main_div {
    padding-bottom: 15px;
  }

  .main_expenses {
    padding: 15px;
    padding-top: 0;
  }

  .expense div {
    padding: 0;
  }

  .expense input,
  .expense .btn,
  .expense select {
    border-radius: 0;
  }

</style>
